/* OOH Guide page — chapter nav active-link + smooth scroll */
(function () {
  var nav = document.querySelector('[data-chapnav]');
  if (!nav) return;
  var links = nav.querySelectorAll('.gd-chap');
  var sectionIds = Array.prototype.slice.call(links).map(function (l) {
    var href = l.getAttribute('href');
    return href && href.startsWith('#') ? href.slice(1) : null;
  }).filter(Boolean);

  // Smooth scroll
  links.forEach(function (l) {
    l.addEventListener('click', function (e) {
      var href = l.getAttribute('href');
      if (href && href.startsWith('#')) {
        var target = document.getElementById(href.slice(1));
        if (target) {
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.scrollY - 60;
          window.scrollTo({ top: top, behavior: 'smooth' });
          history.replaceState(null, '', href);
        }
      }
    });
  });

  // Active-link tracking
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var id = entry.target.id;
        links.forEach(function (l) { l.classList.remove('is-active'); });
        var match = nav.querySelector('a[href="#' + id + '"]');
        if (match) match.classList.add('is-active');
      });
    }, { rootMargin: '-25% 0px -65% 0px', threshold: 0 });
    sectionIds.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) obs.observe(el);
    });
  }
})();
